import { isObject, debug } from '@moleculeone/utils';

export function updateState(state, newState) {
  debug(isObject, state);
  debug(isObject, newState);

  const changes = {};
  for (const [key, value] of Object.entries(newState)) {
    if (value !== state[key]) {
      changes[key] = value;
    }
  }

  const result = Object.keys(changes).length > 0 ? { ...state, ...changes } : state;
  return debug(isObject, result);
}

export function decorateErrorWithPathname(state, error = null) {
  if (!error) {
    return null;
  }

  const { pathname } = state.router.location;

  return {
    ...error,
    data: {
      ...error.data,
      pathname,
    },
  };
}

export function mergeState(objValue, srcValue) {
  if (Array.isArray(objValue)) {
    return srcValue;
  }

  return undefined;
}

export function defaultProcessingState() {
  return {
    processing: 0,
    error: null,
  };
}
